import {IvalidationData  } from './validation.types'
import { ValidationMessage, IValidationMessage } from '../common'
import { AppConstants as _app } from '@/shared/app.constants'

export class validationData implements IvalidationData {
    validationMessages: Array<IValidationMessage>

    constructor(workspace: IvalidationData) {
        this.validationMessages = (workspace.validationMessages || []).map((x) => new ValidationMessage(x))
    }
}

